// extracted by mini-css-extract-plugin
export default {"wrapper":"FilesModal_wrapper__GJgUz","content":"FilesModal_content__iZ5y4","close_window":"FilesModal_close_window__WC-NJ","href":"FilesModal_href__Aoy9M"};